export const SET_FACETRACKING_VIDEOS = 'FACE_TRACK/SET_FACETRACK_VIDEOS'
export const SET_FACETRACKING_VIDEOBLOBS = 'FACE_TRACK/SET_FACETRACK_VIDEOBLOBS'
export const SET_FACETRACKING_VIDEO = 'FACE_TRACK/SET_FACETRACK_VIDEO' // TODO: Remove after python changes made
export const SET_FACETRACKING_VIDEOBLOB = 'FACE_TRACK/SET_FACETRACK_VIDEOBLOB' // TODO: Remove after python changes made
export const SET_FACETRACKING_AUDIO = 'FACE_TRACK/SET_FACETRACK_AUDIO'
export const SET_FACETRACKING_ENABLED = 'FACE_TRACK/SET_FACETRACKING_ENABLED'
export const SET_FACETRACKING_RATIO = 'FACE_TRACK/SET_FACETRACKING_RATIO'
export const SET_FACETRACKING_ENABLED_SEGMENTATIONS =
  'FACE_TRACK/SET_FACETRACKING_ENABLED_SEGMENTATIONS'
